import React, { useEffect, useRef, useState } from 'react';
import { RefreshCw, Info } from 'lucide-react';
import Speedometer from './Speedometer';
import styles from './MileageSimulatorTab.module.css';
import ModalBarChart_Params from './ModalBarChart_Params';
import ModalGauge_Params from './ModalGauge_Params';
import useHttp from '../../../../hook/use-http';
import { API_URL_MAIN } from '../../../../constants/driveglobalfilterinitalstates_bus';


const ParametersSection = ({
  energyEfficiency,
  distance,
  filterdata,
}, props) => {

  const [activeTab, setActiveTab] = useState('Speed');
  const [gaugeData, setGaugeData] = useState({})
  const { sendReq: fetchData } = useHttp();
  const [sliderValue, setSliderValue] = useState(22);
  const [maxRange, setMaxRange] = useState(0)
  const [refresh, setRefresh] = useState(0);
  const [analyzed, setAnalyzed] = useState({ energySaved: 0, saving: 0 })
  const [simulatordata, setSimulatorData] = useState();

  const tabs = [
    { id: 'Speed', label: 'Speed', icon: '/assets/Mileage Simulator Icons/speed.png' },
    { id: 'AccPedal', label: 'Acc. Pedal', icon: '/assets/Mileage Simulator Icons/acc. pedal.png' },
    { id: 'Idling', label: 'Idling', icon: '/assets/Mileage Simulator Icons/idling.png' },
    // { id: 'Coasting', label: 'Coasting', icon: '/assets/Mileage Simulator Icons/coasting.png' },
    { id: 'Regeneration', label: 'Regeneration', icon: '/assets/Mileage Simulator Icons/regeneration.png' },
    { id: 'MotorRPM', label: 'Motor RPM', icon: '/assets/Mileage Simulator Icons/motor rpm.png' },
    // { id: 'AC_Consumption', label: 'AC Power Consumption kWh/Km', icon: '/assets/Mileage Simulator Icons/ac consumption.png', }
  ];

  const [baselineData, setBaselineData] = useState(null);

const [persistentBehaviourData, setPersistentBehaviourData] = useState({
  percentageTimeSpentInSpeed_0: null,
  maxOfBatteryTemperature: null,
  percentageRegen: null,
  percentageTimeSpentInAcc_pedal_position_1_20_40: null,
  percentageTimeSpentInSpeed_30_50: null,
  percentageTimeSpentInMotorspeed_1000_2000: null,
  sumOfTotalACPowerConsumptionkWhPerKm: null,
  percentageTimeSpentInAcOn: null,
  percentageTimeSpentInIdling: null,
  percentageCoasting: null,
  City: null
});

const [persistentEnergyEfficiency, setPersistentEnergyEfficiency] = useState(null);

const [analyzedTabData, setAnalyzedTabData] = useState({
  Speed: null,
  AccPedal: null,
  Idling: null,
  Coasting: null,
  Regeneration: null,
  MotorRPM: null,
  AC_Consumption: null
});

  const [initialData, setInitialData] = useState({
    label: "",
    currentValue: 0
  })

  const benchMarks = {
    Speed: 25,
    AccPedal: 24,
    Idling: 31,
    Coasting: 57,
    Regeneration: 42,
    MotorRPM: 13,
    AC_Consumption: 0 // to be discuss with Vivek
  }

  const barColor = () => {
    if (activeTab == "Idling") {
      return initialData.currentValue <= benchMarks?.[activeTab]
    }
    else {
      return initialData.currentValue >= benchMarks?.[activeTab]
    }

  }


  const [tabContent, setTabContent] = useState({
    Speed: {
      title: 'Speed (30 - 50 Km/h)',
      benchmark: benchMarks.Speed + "%", //'25%',
      impact: '--',
      impactDirection: 'up',
      impactValue: '(-- kwh/km)',
      percentage: '32.15%',
      benchmarkPercentage: '25%',
      benchmarkPosition: 25,
      defaultValue: 20,
      currentValue: 20,  // Default slider position (less than 25% benchmark)
      defaultRange: { start: 30, end: 50 },
      tips: [
        'Maintain steady speed between 30-50 km/h for optimal energy efficiency.',
        'Your driving percentage at Speed (30-50 Km/h) is --.',
        'Excessive speeding will result in increased energy consumption.',
        'Maintaining consistent speed helps achieve better mileage performance.'
      ],
      spectrum: [
        { range: '0-20', percentage: '0' },
        { range: '20-30', percentage: '0' },
        { range: '30-50', percentage: '0', active: true },
        { range: '50-60', percentage: '0' },
        { range: '60+', percentage: '0' }
      ]
    },
    AccPedal: {
      title: 'Acc. Ped. (20% - 40%)',
      benchmark: benchMarks.AccPedal + "%",  // '24%',
      impact: '--',
      impactDirection: 'up',
      impactValue: '(-- kwh/km)',
      percentage: '28.45%',
      benchmarkPercentage: '24%',
      benchmarkPosition: 24,
      defaultValue: 20,
      currentValue: 20,  // Default slider position (less than 24% benchmark)
      defaultRange: { start: 20, end: 40 },
      tips: [
        'Press the Accelerator pedal between 20% to 40% level to get maximum Energy economy.',
        'Your driving percentage at Acc. Ped. (20% - 40%) is 28.45%.',
        'Fully depressing the accelerator will result in increased energy consumption.',
        'Applying minimal pressure may prevent the vehicle from reaching top gear performance.'
      ],
      spectrum: [
        { range: '0-20', percentage: '0' },
        { range: '20-40', percentage: '0', active: true },
        { range: '40-60', percentage: '0' },
        { range: '60-80', percentage: '0' },
        { range: '80-100', percentage: '0' }
      ]
    },
    Idling: {
      title: 'Idling (%)',
      benchmark: benchMarks.Idling + "%",
      impact: '--',
      impactDirection: 'up',
      impactValue: '(-- kwh/km)',
      percentage: '45.20%',
      benchmarkPercentage: '31%',
      benchmarkPosition: 31,
      defaultValue: 25,
      currentValue: 20,  // Default slider position (less than 31% benchmark)
      staticDataPercentage: '20%', // Static default value (less than benchmark)
      staticDataPosition: 40,
      hasScrollbar: true,
      scrollbarLabel: 'Idling Percentage',
      scrollbarUnit: '%',
      tips: [
        'Keep idling percentage at optimal level to optimize energy consumption.',
        'Your driving percentage at Idling is 20.00%.',
        'Extended idling periods waste energy and increase emissions.',
        'Turn off engine during longer stops to save energy.'
      ]
    },
    Coasting: {
      title: 'Coasting (%)',
      benchmark: benchMarks.Coasting + "%",
      impact: '--',
      impactDirection: 'up',
      impactValue: '(-- kwh/km)',
      percentage: '18.75%',
      benchmarkPercentage: '57%',
      benchmarkPosition: 57,
      defaultValue: 45,
      currentValue: 20,  // Default slider position (less than 57% benchmark)
      staticDataPercentage: '35%', // Static default value (less than benchmark)
      staticDataPosition: 35,
      hasScrollbar: true,
      scrollbarLabel: 'Coasting Percentage',
      scrollbarUnit: '%',
      tips: [
        'Utilize coasting at optimal percentage for energy efficiency.',
        'Your driving percentage at Coasting is 35.00%.',
        'Coasting helps reduce energy consumption on downhill slopes.',
        'Proper coasting technique can significantly improve overall mileage.'
      ]
    },
    Regeneration: {
      title: 'Regeneration (%)',
      benchmark: benchMarks.Regeneration + "%",
      impact: '--',
      impactDirection: 'up',
      impactValue: '(-- kwh/km)',
      percentage: '12.40%',
      benchmarkPercentage: '42%',
      benchmarkPosition: 42,
      defaultValue: 30,
      currentValue: 20,  // Default slider position (less than 42% benchmark)
      staticDataPercentage: '25%', // Static default value (less than benchmark)
      staticDataPosition: 25,
      hasScrollbar: true,
      scrollbarLabel: 'Regeneration Percentage',
      scrollbarUnit: '%',
      tips: [
        'Maintain regeneration at optimal percentage for energy recovery.',
        'Your driving percentage at Regeneration is 25.00%.',
        'Regenerative braking helps recover energy and improve efficiency.',
        'Smooth deceleration maximizes regeneration benefits.'
      ]
    },
    MotorRPM: {
      title: 'Motor RPM (1000 - 2000)',
      benchmark: benchMarks.MotorRPM + "%",
      impact: '--',
      impactDirection: 'up',
      impactValue: '(-- kwh/km)',
      percentage: '28.60%',
      benchmarkPercentage: '13%',
      benchmarkPosition: 13,
      defaultValue: 30,
      currentValue: 20,  // Default slider position (corresponds to 1500 RPM)
      defaultRange: { start: 1000, end: 2000 },
      tips: [
        'Keep motor RPM between 1000-2000 for optimal energy efficiency.',
        'Your driving percentage at Motor RPM (1000-2000) is 28.60%.',
        'High RPM operation increases energy consumption significantly.',
        'Maintaining optimal RPM range ensures engine longevity.'
      ],
      spectrum: [
        { range: '0-1000', percentage: '0' },
        { range: '1000-2000', percentage: '0', active: true },
        { range: '2000-3000', percentage: '0' },
        { range: '3000-4000', percentage: '0' },
        { range: '4000+', percentage: '0' }
      ],
      hasRPMSlider: true,
      rpmMin: 0,
      rpmMax: 5000
    },
    AC_Consumption: {
      title: 'AC Consumption',
      benchmark: benchMarks.AC_Consumption + "%",
      impact: '--',
      impactDirection: 'up',
      impactValue: '(-- kwh/km)',
      percentage: '45.20%',
      benchmarkPercentage: benchMarks.AC_Consumption + "%",
      benchmarkPosition: benchMarks.AC_Consumption,
      defaultValue: 25,
      currentValue: 20, 
      staticDataPercentage: '20%',
      staticDataPosition: 40,
      hasScrollbar: true,
      scrollbarLabel: 'AC Consumption Percentage',
      scrollbarUnit: '%',
      tips: [
        'Keep AC Consumption percentage at optimal level to optimize energy consumption.',
        'Your driving percentage at AC Consumption is 20.00%.',
        'Extended AC Consumption periods waste energy and increase emissions.',
        'Turn off engine during longer stops to save energy.'
      ]
    }
  });

  function getMaxActivePercentage(data) {
    const updated = data

    let activeIndex = updated.findIndex(item => item.active);
    let active = updated[activeIndex];
    let totalPercentage = 0
    let cal = updated.map(item => {
      if (item.percentage > 2 && !item.active) {
        totalPercentage = totalPercentage + (Number(item.percentage) - 2)
      }
      if (item.active) {
        totalPercentage = totalPercentage + Number(item.percentage)
      }
    })

    return totalPercentage
  }



  useEffect(() => {
  setAnalyzed(prev => ({
    ...prev,
    savings: 0,
    energySaved: 0
  }))

  let apiEnd = activeTab == "Speed" ? "simulator_Vehicle_Speed_Distribution"
    : activeTab == "AccPedal" ? "simulator_Accelarator_Pedal"
      : activeTab == "Idling" ? "simulator_idling_percentage"
        : activeTab == "Coasting" ? "simulator_Coasting"
          : activeTab == "Regeneration" ? "simulator_Regeneration"
            : activeTab == "AC_Consumption" ? "simulator_AC_Consumption"
              : "simulator_rpm"

  fetchData(
    {
      url: `${API_URL_MAIN}simulator/${apiEnd}`,
      body: { filterdata }
    },
    (res) => {
      let data = res?.[0] || {}
      let tempSpectrum = []
      
      // Check if this tab has been analyzed
      const hasBeenAnalyzed = analyzedTabData[activeTab] !== null;
      
      if (activeTab == "Speed") {
        const newSpectrum = [
          { range: '0-20', percentage: Number(data?.Vehicle_Speed_Distribution_0_20?.value).toFixed(2) ?? 0 },
          { range: '20-30', percentage: Number(data?.Vehicle_Speed_Distribution_20_30?.value).toFixed(2) ?? 0 },
          { range: '30-50', percentage: Number(data?.Vehicle_Speed_Distribution_30_50?.value).toFixed(2) ?? 0, active: true },
          { range: '50-60', percentage: Number(data?.Vehicle_Speed_Distribution_50_60?.value).toFixed(2) ?? 0 },
          { range: '60+', percentage: Number(data?.["Vehicle_Speed_Distribution_60+"]?.value).toFixed(2) ?? 0 }
        ];
        
        setTabContent(prev => ({
          ...prev,
          Speed: {
            ...prev.Speed,
            spectrum: hasBeenAnalyzed ? analyzedTabData.Speed.spectrum : newSpectrum,
            defaultValue: data?.Vehicle_Speed_Distribution_30_50?.value?.toFixed(2),
            // Only update currentValue if not analyzed
            ...(hasBeenAnalyzed ? {} : { currentValue: data?.Vehicle_Speed_Distribution_30_50?.value?.toFixed(2) })
          }
        }));
        
        const shouldUpdateGauge = persistentEnergyEfficiency === null;
        if (shouldUpdateGauge) {
          setGaugeData(prev => ({
            ...prev,
            speed: data?.["kWh/km"]?.value?.toFixed(2),
            initialSpeed: data?.["kWh/km"]?.value?.toFixed(2)
          }))
        } else {
          setGaugeData(prev => ({
            ...prev,
            initialSpeed: data?.["kWh/km"]?.value?.toFixed(2)
          }))
        }
        
        if (!hasBeenAnalyzed) {
          setSliderValue(data?.Vehicle_Speed_Distribution_30_50?.value?.toFixed(2))
        }
        setInitialData(prev => ({ ...prev, label: "Speed", currentValue: data?.Vehicle_Speed_Distribution_30_50?.value?.toFixed(2) }))
        tempSpectrum = newSpectrum;
      }

      if (activeTab == "AccPedal") {
        const newSpectrum = [
          { range: '0-20', percentage: Number(data?.['Accelarator Pedal_0_20']?.value).toFixed(2) ?? 0 },
          { range: '20-40', percentage: Number(data?.["Accelarator Pedal_20_40"]?.value).toFixed(2) ?? 0, active: true },
          { range: '40-60', percentage: Number(data?.["Accelarator Pedal_40_60"]?.value).toFixed(2) ?? 0 },
          { range: '60-80', percentage: Number(data?.["Accelarator Pedal_60_80"]?.value).toFixed(2) ?? 0 },
          { range: '80-100', percentage: Number(data?.["Accelarator Pedal_80_100"]?.value).toFixed(2) ?? 0 }
        ];
        
        setTabContent(prev => ({
          ...prev,
          AccPedal: {
            ...prev.AccPedal,
            spectrum: hasBeenAnalyzed ? analyzedTabData.AccPedal.spectrum : newSpectrum,
            defaultValue: data?.["Accelarator Pedal_20_40"]?.value?.toFixed(2),
            ...(hasBeenAnalyzed ? {} : { currentValue: data?.["Accelarator Pedal_20_40"]?.value?.toFixed(2) })
          }
        }));
        
        const shouldUpdateGauge = persistentEnergyEfficiency === null;
        if (shouldUpdateGauge) {
          setGaugeData(prev => ({
            ...prev,
            speed: data?.["kWh/km"]?.value?.toFixed(2),
            initialSpeed: data?.["kWh/km"]?.value?.toFixed(2)
          }))
        } else {
          setGaugeData(prev => ({
            ...prev,
            initialSpeed: data?.["kWh/km"]?.value?.toFixed(2)
          }))
        }
        
        if (!hasBeenAnalyzed) {
          setSliderValue(data?.["Accelarator Pedal_20_40"]?.value?.toFixed(2))
        }
        setInitialData(prev => ({ ...prev, label: "AccPedal", currentValue: data?.["Accelarator Pedal_20_40"]?.value?.toFixed(2) }))
        tempSpectrum = newSpectrum;
      }

      if (activeTab == "Idling") {
        setTabContent(prev => ({
          ...prev,
          Idling: {
            ...prev.Idling,
            defaultValue: data?.Idling_percentage?.value?.toFixed(2),
            ...(hasBeenAnalyzed ? {} : { currentValue: data?.Idling_percentage?.value?.toFixed(2) })
          }
        }));

        if (!hasBeenAnalyzed) {
          setSliderValue(data?.Idling_percentage?.value?.toFixed(2))
        }
        
        const shouldUpdateGauge = persistentEnergyEfficiency === null;
        if (shouldUpdateGauge) {
          setGaugeData(prev => ({
            ...prev,
            speed: data?.["kWh/km"]?.value?.toFixed(2),
            initialSpeed: data?.["kWh/km"]?.value?.toFixed(2)
          }))
        } else {
          setGaugeData(prev => ({
            ...prev,
            initialSpeed: data?.["kWh/km"]?.value?.toFixed(2)
          }))
        }
        setInitialData(prev => ({ ...prev, label: "Idling", currentValue: data?.Idling_percentage?.value?.toFixed(2) }))
      }

      if (activeTab == "Coasting") {
        setTabContent(prev => ({
          ...prev,
          Coasting: {
            ...prev.Coasting,
            defaultValue: data?.Coasting_percentage?.value?.toFixed(2),
            ...(hasBeenAnalyzed ? {} : { currentValue: data?.Coasting_percentage?.value?.toFixed(2) })
          }
        }));
        
        if (!hasBeenAnalyzed) {
          setSliderValue(data?.Coasting_percentage?.value?.toFixed(2))
        }
        
        const shouldUpdateGauge = persistentEnergyEfficiency === null;
        if (shouldUpdateGauge) {
          setGaugeData(prev => ({
            ...prev,
            speed: data?.["kWh/km"]?.value?.toFixed(2),
            initialSpeed: data?.["kWh/km"]?.value?.toFixed(2)
          }))
        } else {
          setGaugeData(prev => ({
            ...prev,
            initialSpeed: data?.["kWh/km"]?.value?.toFixed(2)
          }))
        }
        setInitialData(prev => ({ ...prev, label: "Coasting", currentValue: data?.Coasting_percentage?.value?.toFixed(2) }))
      }

      if (activeTab == "Regeneration") {
        setTabContent(prev => ({
          ...prev,
          Regeneration: {
            ...prev.Regeneration,
            defaultValue: data?.Regeneration_percentage?.value?.toFixed(2),
            ...(hasBeenAnalyzed ? {} : { currentValue: data?.Regeneration_percentage?.value?.toFixed(2) })
          }
        }));
        
        if (!hasBeenAnalyzed) {
          setSliderValue(data?.Regeneration_percentage?.value?.toFixed(2))
        }
        
        const shouldUpdateGauge = persistentEnergyEfficiency === null;
        if (shouldUpdateGauge) {
          setGaugeData(prev => ({
            ...prev,
            speed: data?.["kWh/km"]?.value?.toFixed(2),
            initialSpeed: data?.["kWh/km"]?.value?.toFixed(2)
          }))
        } else {
          setGaugeData(prev => ({
            ...prev,
            initialSpeed: data?.["kWh/km"]?.value?.toFixed(2)
          }))
        }
        setInitialData(prev => ({ ...prev, label: "Regeneration", currentValue: data?.Regeneration_percentage?.value?.toFixed(2) }))
      }

      if (activeTab == "MotorRPM") {
        const newSpectrum = [
          { range: '0-1000', percentage: Number(data?.RPM_0_1000?.value).toFixed(2) ?? 0 },
          { range: '1000-2000', percentage: Number(data?.RPM_1000_2000?.value).toFixed(2) ?? 0, active: true },
          { range: '2000-3000', percentage: Number(data?.RPM_2000_3000?.value).toFixed(2) ?? 0 },
          { range: '3000-4000', percentage: Number(data?.RPM_3000_4000?.value).toFixed(2) ?? 0 },
          { range: '4000+', percentage: Number(data?.["RPM_4000+"]?.value).toFixed(2) ?? 0 }
        ];
        
        setTabContent(prev => ({
          ...prev,
          MotorRPM: {
            ...prev.MotorRPM,
            spectrum: hasBeenAnalyzed ? analyzedTabData.MotorRPM.spectrum : newSpectrum,
            defaultValue: data?.RPM_1000_2000?.value?.toFixed(2),
            ...(hasBeenAnalyzed ? {} : { currentValue: data?.RPM_1000_2000?.value?.toFixed(2) })
          }
        }));
        
        const shouldUpdateGauge = persistentEnergyEfficiency === null;
        if (shouldUpdateGauge) {
          setGaugeData(prev => ({
            ...prev,
            speed: data?.["kWh/km"]?.value?.toFixed(2),
            initialSpeed: data?.["kWh/km"]?.value?.toFixed(2)
          }))
        } else {
          setGaugeData(prev => ({
            ...prev,
            initialSpeed: data?.["kWh/km"]?.value?.toFixed(2)
          }))
        }
        
        if (!hasBeenAnalyzed) {
          setSliderValue(data?.RPM_1000_2000?.value?.toFixed(2))
        }
        setInitialData(prev => ({ ...prev, label: "MotorRPM", currentValue: data?.RPM_1000_2000?.value?.toFixed(2) }))
        tempSpectrum = newSpectrum;
      }
      
      if (activeTab == "AC_Consumption") {
        setTabContent(prev => ({
          ...prev,
          AC_Consumption: {
            ...prev.AC_Consumption,
            defaultValue: data?.AC_Consumption_percentage?.value?.toFixed(2),
            ...(hasBeenAnalyzed ? {} : { currentValue: data?.AC_Consumption_percentage?.value?.toFixed(2) })
          }
        }));

        if (!hasBeenAnalyzed) {
          setSliderValue(data?.AC_Consumption_percentage?.value?.toFixed(2))
        }
        
        const shouldUpdateGauge = persistentEnergyEfficiency === null;
        if (shouldUpdateGauge) {
          setGaugeData(prev => ({
            ...prev,
            speed: data?.["kWh/km"]?.value?.toFixed(2),
            initialSpeed: data?.["kWh/km"]?.value?.toFixed(2)
          }))
        } else {
          setGaugeData(prev => ({
            ...prev,
            initialSpeed: data?.["kWh/km"]?.value?.toFixed(2)
          }))
        }
        setInitialData(prev => ({ ...prev, label: "AC_Consumption", currentValue: data?.AC_Consumption_percentage?.value?.toFixed(2) }))
      }

      let max = getMaxActivePercentage(tempSpectrum)
      setMaxRange(Math.ceil(max))
    }
  );

}, [filterdata, activeTab, refresh, analyzedTabData]);

  const highestRef = useRef(null);
  const lastHeightsRef = useRef(null);



  useEffect(() => {
    highestRef.current = null;
    lastHeightsRef.current = null;
  }, [activeTab]);

  useEffect(() => {
  fetchData(
    {
      url: API_URL_MAIN + 'simulator/mileage_simulator',
      body: { filterdata },
    },
    (res) => {
      if (res && res.length > 0) {
        const data = res[0];
        const baseline = {
          percentageTimeSpentInSpeed_0: data.median_TimeSpentInSpeed_0?.values?.["50.0"] ?? 0,
          maxOfBatteryTemperature: data.median_maxOfBatteryTemperature?.values?.["50.0"] ?? 0,
          percentageRegen: data.median_percentageRegen?.values?.["50.0"] ?? 0,
          percentageTimeSpentInAcc_pedal_position_1_20_40: data.median_Acc_pedal_position_20_40?.values?.["50.0"] ?? 0,
          percentageTimeSpentInSpeed_30_50: data.median_Speed_30_50?.values?.["50.0"] ?? 0,
          percentageTimeSpentInMotorspeed_1000_2000: data.median_Motorspeed?.values?.["50.0"] ?? 0,
          sumOfTotalACPowerConsumptionkWhPerKm: data.median_ACPowerConsumptionkWhPerKm?.values?.["50.0"] ?? 0,
          percentageTimeSpentInAcOn: data.median_Ac_status_per_duration?.values?.["50.0"] ?? 0,
          percentageTimeSpentInIdling: data.median_Idling_percentage?.values?.["50.0"] ?? 0,
          percentageCoasting: data.median_Coasting_percentage?.values?.["50.0"] ?? 0,
          City: filterdata.CITY?.[0] ?? "",
        };
        setBaselineData(baseline);
      }
    }
  );
}, [filterdata]);


  function handleSlider(val) {

    let newVal = parseFloat(val);
    if (isNaN(newVal)) return;

    newVal = Number(newVal.toFixed(2));

    let spectrum = tabContent?.[activeTab]?.spectrum.map(item => ({
      ...item,
      percentage: Number(item.percentage)
    }));

    const activeIndex = spectrum.findIndex(item => item.active);
    const oldVal = spectrum[activeIndex]?.percentage ?? 0;

    const diff = newVal - oldVal;

    const filtered = spectrum.filter(item => !item.active && item.percentage > 2.0);
    const CurrentValue = spectrum.filter(item => item.range == highestRef.current?.range)?.[0]?.percentage

    let newHighest = filtered.reduce((max, item) => {
      return item.percentage > max.percentage ? item : max;
    }, { percentage: 0 });


    if (!highestRef.current || CurrentValue <= 2) {
      if (newHighest.range /* && !lastHeightsRef.current */) {
        highestRef.current = newHighest;
      }
    }

    const highest = highestRef.current;

    spectrum = spectrum.map(item => {
      if (item.range === highest.range) {
        return {
          ...item,
          percentage: Number((item.percentage - diff).toFixed(2)) <= 2.5 ? 2.0 : Number((item.percentage - diff).toFixed(2))
        };
      }
      if (item.active) {
        return {
          ...item,
          percentage: newVal
        };
      }
      return item;
    })



    if (spectrum?.filter(item => item.percentage <= 2).length == spectrum?.length - 1) {
      lastHeightsRef.current = true
    }

    if (newVal <= maxRange && newVal > 1.99) {
      setSliderValue(newVal);
      setTabContent(prev => ({
        ...prev,
        [activeTab]: {
          ...prev[activeTab],
          spectrum
        }
      }));
    }

    // if ((newHighest?.range || diff < 0) && diff < 2) {
    //   setSliderValue(newVal);
    // }

    // setTabContent(prev => ({
    //   ...prev,
    //   [activeTab]: {
    //     ...prev[activeTab],
    //     spectrum
    //   }
    // }));
  }






  const currentContent = tabContent[activeTab];

  // Reset slider to default position ONLY when tab changes (not on every render)
   useEffect(() => {
  const currentContent = tabContent[activeTab];
  const analyzedData = analyzedTabData[activeTab];

  if (analyzedData) {
    // Restore the analyzed value and spectrum
    setSliderValue(analyzedData.sliderValue);
    setTabContent(prev => ({
      ...prev,
      [activeTab]: {
        ...prev[activeTab],
        currentValue: analyzedData.sliderValue,
        spectrum: analyzedData.spectrum || prev[activeTab].spectrum
      }
    }));
  } else {
    // Use currentValue if it exists and differs from defaultValue (meaning it was modified)
    // Otherwise use defaultValue
    const hasBeenModified = currentContent.currentValue !== undefined && 
                           currentContent.currentValue !== currentContent.defaultValue;
    const valueToUse = hasBeenModified ? currentContent.currentValue : currentContent.defaultValue;
    setSliderValue(valueToUse);
  }
}, [activeTab, analyzedTabData]);  // Only depend on activeTab, not currentContent or setSliderValue

  const handleViewDetailedSpectrum = () => {
    // const label = currentContent.title?.split('(')[0]?.trim();
    // const currentValue = parseFloat(sliderValue);  // Use live value
    // const benchmarkValue = currentContent.benchmarkPosition ?? 0;
    // const chartType = ['Idling', 'Coasting', 'Regeneration'].includes(activeTab) ? 'gauge' : 'bar';

    // setModalProps({ label, currentValue, benchmarkValue, chartType }); // ✅ pass currentValue
    // setShowModal(true);
  };

  // Function to calculate dynamic spectrum percentages based on slider value
  const calculateDynamicSpectrum = (sliderValue, content) => {
    if (!content?.spectrum) return [];

    const currentPos = parseInt(sliderValue);
    return content.spectrum.map((segment) => {

      // if (segment.active) {
      //   let basePercentage = parseFloat(segment.percentage);
      //   const adjustment = (currentPos - 50) * 0.2; // Adjust this logic as needed
      //   basePercentage += adjustment;
      //   basePercentage = Math.max(5, Math.min(45, basePercentage)); // Keep it within bounds
      //   return {
      //     ...segment,
      //     percentage: `${basePercentage.toFixed(2)}`
      //   };
      // }

      return segment; // Keep original percentage for inactive segments
    });
  };

  // Function to get dynamic tips based on current slider value
  const getDynamicTips = (content, currentValue) => {
    if (!content?.tips) return [];

    return content?.tips?.map((tip, index) => {
      if (index === 1 && tip.includes('Your driving percentage at')) {
        const sectionName = content?.title.split(' ')[0];
        const fixedValue = `${content.defaultValue}%`;  // Always use slider default
        return `Your driving percentage at ${sectionName} is ${fixedValue}.`;
      }
      return tip;
    });
  };

  const dynamicSpectrum = calculateDynamicSpectrum(sliderValue, currentContent);
  const currentTips = getDynamicTips(currentContent, sliderValue);

  // Function to generate slider CSS variables for coloring
  const getSliderStyles = (content) => {
    const currentValue = parseInt(sliderValue);
    const defaultValue = content.defaultValue || 50;

    return {
      '--slider-value': `${sliderValue}%`,
      '--default-value': `${defaultValue}%`,
      '--static-data-value': `${content.staticDataPosition}%`,
      '--benchmark-value': `${content.benchmarkPosition}%`,
      '--is-above-default': currentValue > defaultValue ? '1' : '0'
    };
  };

  const handleSliderClick = (value, range) => {
    let activeData = tabContent?.[activeTab]?.spectrum
    let temp = activeData.map(item => ({ ...item, active: range == item?.range ? true : false, }))
    setSliderValue(value)

    setTabContent(prev => ({
      ...prev,
      [activeTab]: {
        ...prev?.[activeTab],
        spectrum: temp
      }
    }));


  }

  const renderSpectrum = () => {
    if (currentContent.hasScrollbar) {
      return (
        <div className="mb-4">
          {/* Slider - First, right after "View Detailed Spectrum" */}
          <div className="mb-3">
            <div className="position-relative">
              <input
                type="range"
                className={`form-range ${styles.sliderGreen}  ${barColor() ? styles.coloredSlider : styles.redColoredSlider}`}
                min="0"
                max={activeTab == "AC_Consumption" ? "100" : "100"}
                step={0.1}
                value={sliderValue}
                onChange={(e) => setSliderValue(e.target.value)}
                style={getSliderStyles(currentContent)}
              />



              {/* Benchmark Line */}
              <div
                className={`position-absolute ${styles.benchmarkLine}`}
                style={{
                  left: `${currentContent.benchmarkPosition}%`,
                  top: '15%',
                  transform: 'translateX(-50%)',
                  width: '3px',
                  height: '70%',
                  backgroundColor: '#007bff',
                  borderLeft: '3px dashed #007bff',
                  backgroundColor: 'transparent',
                  zIndex: 10
                }}
              />

              {/* Benchmark Label */}
              <div
                className={`position-absolute small text-primary fw-bold ${styles.benchmarkLabel}`}
                style={{
                  left: `${currentContent.benchmarkPosition}%`,
                  top: '-25px',
                  transform: 'translateX(-50%)',
                  fontSize: '12px'
                }}
              >
                {currentContent.benchmarkPercentage}
              </div>

              <div className="d-flex justify-content-between mt-1">
                <span className="text-muted small">0</span>
                <span className="text-muted small">{activeTab == "AC_Consumption" ? "100" : "100"}</span>
              </div>
            </div>

            {/* Label moved below slider */}
            <div className="d-flex align-items-center gap-3 mt-2 justify-content-center">
              <span className="small text-muted">{currentContent.scrollbarLabel}:</span>
              <span className="fw-bold">{sliderValue}{currentContent.scrollbarUnit}</span>
            </div>
          </div>
        </div>
      );
    }

    return (
      <>
        {/* Slider - First, right after "View Detailed Spectrum" */}
        <div className="mt-5">
          <div className="position-relative">
            <input
              type="range"
              className={`form-range ${styles.sliderGreen} ${barColor() ? styles.coloredSlider : styles.redColoredSlider}`}
              min="0"
              max="100"
              step={0.0001}
              value={sliderValue}
              onChange={(e) => handleSlider(e.target.value, "change")}
              style={getSliderStyles(currentContent)}
            />

            {/* Benchmark Line */}
            <div
              className={`position-absolute ${styles.benchmarkLine}`}
              style={{
                left: `${currentContent.benchmarkPosition}%`,
                top: '15%',
                transform: 'translateX(-50%)',
                width: '3px',
                height: '70%',
                backgroundColor: '#007bff',
                borderLeft: '3px dashed #007bff',
                backgroundColor: 'transparent',
                zIndex: 10
              }}
            />
            {/* Default Value Line (Black Dashed - Center Aligned) */}

            <div
              className={`position-absolute`}
              style={{
                left: `${currentContent.defaultValue}%`,
                top: '0%',
                transform: 'translateX(-50%)',
                width: '0px',
                height: '100%',
                borderLeft: '2px dashed black',
                zIndex: 15 // above the slider
              }}
            />

            {/* Default Value Label */}
            <div
              className={`position-absolute small fw-bold text-dark`}
              style={{
                left: `${currentContent.defaultValue}%`,
                top: '-25px',
                transform: 'translateX(-50%)',
                fontSize: '12px',
                zIndex: 16
              }}
            >
              {currentContent.defaultValue}%
            </div>

            {/* Benchmark Label */}
            <div
              className={`position-absolute small text-primary fw-bold ${styles.benchmarkLabel}`}
              style={{
                left: `${currentContent.benchmarkPosition}%`,
                top: '-25px',
                transform: 'translateX(-50%)',
                fontSize: '12px'
              }}
            >
              {currentContent.benchmarkPercentage}
            </div>
          </div>



          {/* Label moved below slider */}
          <div className="d-flex align-items-center gap-3 mt-2 justify-content-center">
            <span className="small text-muted">
              {currentContent.hasRPMSlider ? 'Adjust RPM:' : 'Adjust Benchmark:'}
            </span>
            <span className="fw-bold">
              {sliderValue}%
            </span>
          </div>
        </div>

        {/* Spectrum Bar - Second, after slider */}
        <div className="mb-3">
          <div className={`d-flex align-items-center position-relative ${styles.spectrumBar}`}>
            <div className="w-100 d-flex">
              {dynamicSpectrum.map((segment, index) => (
                <div
                  key={index}
                  className={`d-flex align-items-center justify-content-center text-white small fw-semibold ${styles.spectrumSegment} ${segment.active ? styles.spectrumSegmentActive : styles.spectrumSegmentInactive
                    }`}
                  style={{
                    flex: 1,
                    cursor: "pointer"
                  }}
                // onClick={() => handleSliderClick(segment?.percentage, segment.range)}
                >
                  {segment.range}
                </div>
              ))}
            </div>
          </div>
          <div className="d-flex w-100 mt-1">
            {dynamicSpectrum.map((segment, index) => (
              <div
                key={index}
                className="text-center small"
                style={{
                  flex: 1,
                  margin: '0 1px'
                }}
              >
                ({segment.percentage}{"%"})
              </div>
            ))}
          </div>
        </div>
      </>
    );
  };

  async function handleAnalyser() {
    // Don't proceed if baseline data isn't loaded yet
    if (!baselineData) {
      // console.log("Baseline data not loaded yet");
      return;
    }

    // Use persistent data if it exists, otherwise use baseline
    const currentBehaviourData = {
      percentageTimeSpentInSpeed_0: persistentBehaviourData.percentageTimeSpentInSpeed_0 ?? baselineData.percentageTimeSpentInSpeed_0,
      maxOfBatteryTemperature: persistentBehaviourData.maxOfBatteryTemperature ?? baselineData.maxOfBatteryTemperature,
      percentageRegen: persistentBehaviourData.percentageRegen ?? baselineData.percentageRegen,
      percentageTimeSpentInAcc_pedal_position_1_20_40: persistentBehaviourData.percentageTimeSpentInAcc_pedal_position_1_20_40 ?? baselineData.percentageTimeSpentInAcc_pedal_position_1_20_40,
      percentageTimeSpentInSpeed_30_50: persistentBehaviourData.percentageTimeSpentInSpeed_30_50 ?? baselineData.percentageTimeSpentInSpeed_30_50,
      percentageTimeSpentInMotorspeed_1000_2000: persistentBehaviourData.percentageTimeSpentInMotorspeed_1000_2000 ?? baselineData.percentageTimeSpentInMotorspeed_1000_2000,
      sumOfTotalACPowerConsumptionkWhPerKm: persistentBehaviourData.sumOfTotalACPowerConsumptionkWhPerKm ?? baselineData.sumOfTotalACPowerConsumptionkWhPerKm,
      percentageTimeSpentInAcOn: persistentBehaviourData.percentageTimeSpentInAcOn ?? baselineData.percentageTimeSpentInAcOn,
      percentageTimeSpentInIdling: persistentBehaviourData.percentageTimeSpentInIdling ?? baselineData.percentageTimeSpentInIdling,
      percentageCoasting: persistentBehaviourData.percentageCoasting ?? baselineData.percentageCoasting,
      City: filterdata.CITY?.[0] ?? "",
    };

    // Clone for desired behaviour
    const desiredBehaviourData = { ...currentBehaviourData };

    // Update the specific parameter based on active tab
    if (activeTab === "Speed") {
      desiredBehaviourData.percentageTimeSpentInSpeed_30_50 = Number(sliderValue);
    }
    if (activeTab === "AccPedal") {
      desiredBehaviourData.percentageTimeSpentInAcc_pedal_position_1_20_40 = Number(sliderValue);
    }
    if (activeTab === "Idling") {
      desiredBehaviourData.percentageTimeSpentInSpeed_0 = Number(sliderValue);
    }
    if (activeTab === "Coasting") {
      desiredBehaviourData.percentageCoasting = Number(sliderValue);
    }
    if (activeTab === "Regeneration") {
      desiredBehaviourData.percentageRegen = Number(sliderValue);
    }
    if (activeTab === "MotorRPM") {
      desiredBehaviourData.percentageTimeSpentInMotorspeed_1000_2000 = Number(sliderValue);
    }
    if (activeTab === "AC_Consumption") {
      desiredBehaviourData.percentageTimeSpentInAcOn = Number(sliderValue);
    }

    // Prepare body for API
    let bodyObj = {
      "current_driving_behaviour_dict": currentBehaviourData,
      "desired_driving_behaviour_dict": desiredBehaviourData,
      "current_drive_efficiency": persistentEnergyEfficiency ?? energyEfficiency
    };

    // console.log("Sending to API:", bodyObj);

    // Call estimate_efficiency API
    fetchData(
      {
        url: `${API_URL_MAIN}simulator/estimate_efficiency`,
        body: bodyObj
      },
      (res) => {
        // console.log("API Response:", res);

        // Get the new efficiency value
        const newEfficiency = res?.estimated_efficiency_kwh_per_km;

        // Add validation to ensure we have a valid number
        if (newEfficiency !== undefined && newEfficiency !== null && !isNaN(newEfficiency)) {
          setGaugeData(prev => ({
            ...prev,
            speed: Number(newEfficiency.toFixed(2))
          }));

          setPersistentBehaviourData(desiredBehaviourData);
          setPersistentEnergyEfficiency(newEfficiency);

          // Store the analyzed slider value and spectrum for this tab
          setAnalyzedTabData(prev => ({
            ...prev,
            [activeTab]: {
              sliderValue: sliderValue,
              spectrum: tabContent[activeTab].spectrum,
              analyzedAt: new Date().toISOString()
            }
          }));

          // Update currentValue in tabContent to persist the slider value
          setTabContent(prev => ({
            ...prev,
            [activeTab]: {
              ...prev[activeTab],
              currentValue: sliderValue
            }
          }));

          // Calculate savings
          let costSaving = 0;
          if (filterdata?.CITY?.[0] == "Bangalore") {
            costSaving = 6.42;
          } else if (filterdata?.CITY?.[0] == "Jammu") {
            costSaving = 8.6;
          } else if (filterdata?.CITY?.[0] == "Srinagar") {
            costSaving = 6.9;
          } else if (filterdata?.CITY?.[0] == "Delhi") {
            costSaving = 5.27;
          }

          const energySaved = (res?.current_efficiency_kwh_per_km * distance) - (res?.estimated_efficiency_kwh_per_km * distance);
          const savings = energySaved * costSaving;

          setAnalyzed(prev => ({
            ...prev,
            savings,
            energySaved
          }));

          // console.log("Updated persistent data:", desiredBehaviourData);
          // console.log("Updated efficiency:", newEfficiency);
          // console.log("Analysis stored for tab:", activeTab);
        } else {
          // console.error("Invalid efficiency value received:", newEfficiency);
        }
      }
    );
  }


  const handleReset = () => {
    // Reset ALL tabs to their default values
    setAnalyzedTabData({
      Speed: null,
      AccPedal: null,
      Idling: null,
      Coasting: null,
      Regeneration: null,
      MotorRPM: null,
      AC_Consumption: null
    });

    // Reset persistent data
    setPersistentBehaviourData({
      percentageTimeSpentInSpeed_0: null,
      maxOfBatteryTemperature: null,
      percentageRegen: null,
      percentageTimeSpentInAcc_pedal_position_1_20_40: null,
      percentageTimeSpentInSpeed_30_50: null,
      percentageTimeSpentInMotorspeed_1000_2000: null,
      sumOfTotalACPowerConsumptionkWhPerKm: null,
      percentageTimeSpentInAcOn: null,
      percentageTimeSpentInIdling: null,
      percentageCoasting: null,
      City: null
    });

    setPersistentEnergyEfficiency(null);

    // Reset gauge to initial
    setGaugeData(prev => ({
      ...prev,
      speed: prev.initialSpeed
    }));

    // Reset current tab's slider to default
    const currentContent = tabContent[activeTab];
    setSliderValue(currentContent.defaultValue);

    // Reset all currentValues to defaultValues
    setTabContent(prev => {
      const updated = {};
      Object.keys(prev).forEach(key => {
        updated[key] = {
          ...prev[key],
          currentValue: prev[key].defaultValue
        };
      });
      return updated;
    });

    // Trigger refresh
    setRefresh(prev => prev + 1);

    // console.log("All tabs reset to default values");
  };

  // impactCalculator should be OUTSIDE and SEPARATE from handleAnalyser
  const impactCalculator = () => {
    let up = true;

    let impactedValue = gaugeData.initialSpeed - gaugeData.speed;

    if (activeTab === "Idling") {
      if (impactedValue > 0) {
        up = false;
      } else {
        up = true;
      }
    } else {
      if (impactedValue < 0) {
        up = false;
      } else {
        up = true;
      }
    }
    // }


    return (
      <>
        <span className={`fw-bold ${up
          ? styles.impactArrowUp
          : styles.impactArrowDown
          }`}>
          {up ? '▲' : '▼'}
        </span>
        <span className="small text-muted">{'( ' + impactedValue?.toFixed(2) + ' kWh/km )'}</span>

      </>
    )
  }


  const modalTarget = ["Speed", "AccPedal", "MotorRPM"]?.includes(activeTab)
    ? "#modalBarChart_MSbus_Stimulator"
    : ["Idling", "Coasting", "Regeneration"]?.includes(activeTab) ? "#modalGauge_MSbus_Stimulator"
      : undefined;
  return (
    <div className="bg-white rounded shadow-sm mt-4">
      <div className="p-3">
        <div className={`d-flex align-items-center gap-2 overflow-auto ${styles.tabsContainer}`}>

          {/* mytabs */}

          {tabs.map((tab) => (
            <button
              key={tab.id}
              className={`d-flex align-items-center gap-2 px-3 py-2 text-nowrap ${activeTab === tab.id
                ? `text-white fw-semibold ${styles.tabButtonActive}`
                : `text-muted ${styles.tabButton}`
                }`}
              onClick={() => setActiveTab(tab.id)}
            >
              <span className={styles.tabIcon}>
                <img
                  src={tab.icon}
                  alt={tab.label}
                  className={styles.tabIcon}
                />
              </span>
              <span>{tab.label}</span>
            </button>
          ))}
        </div>
      </div>

      {/* Tab Content */}
      <div className="p-4 border-top" >
        <div className="row">
          <div className="col-md-8">
            {/* Tab Header */}
            <div className="d-flex align-items-center justify-content-between mb-3">
              <div className="d-flex align-items-center gap-2">
                <img
                  src={tabs.find(t => t.id === activeTab)?.icon}
                  alt={activeTab}
                  className={styles.tabHeaderIcon}
                />
                <h5 className="mb-0 fw-bold">{currentContent?.title}</h5>
              </div>
              <div className="d-flex align-items-center gap-3" >
                <div className="text-end">
                  <div className="small text-muted">Impact on Energy Efficiency</div>
                  <div className="d-flex align-items-center gap-1">
                    {impactCalculator()}
                  </div>
                </div>
              </div>
            </div>

            <div className="mb-3" >
              <div className="small text-muted mb-1">Benchmark : {currentContent.benchmark}</div>
            </div>

            {/* Tips */}
            <div className="mb-4" >
              {currentTips.map((tip, index) => (
                <div key={index} className="d-flex align-items-start gap-2 mb-2">
                  <span className={`${styles.bulletPoint} mt-1`}>●</span>
                  <p className="mb-0 small">{tip}</p>
                </div>
              ))}
            </div>

            {/* View Detailed Spectrum */}
            <div className="mb-4" >
              <div className="d-flex align-items-center gap-2 mb-3">
                {
                  activeTab == "AC_Consumption" ? <></> :
                    <>
                      <span
                        className={`fw-semibold ${styles.spectrumLabel}`}

                        onClick={handleViewDetailedSpectrum} // 🔹 Clickable
                      >
                        {currentContent.hasScrollbar ? 'View Detailed Spectrum' : 'View Detailed Spectrum'}
                      </span>
                      <Info style={{ cursor: 'pointer' }} size={16} className={styles.spectrumIcon} data-toggle="modal" data-target={modalTarget} />
                    </>
                }

              </div>

              {renderSpectrum()}
            </div>

            {/* Action Buttons */}
            <div className="d-flex gap-3 mt-4">
              <button className={styles.refreshButton} onClick={handleReset}>
  <RefreshCw size={16} />
  Reset All
</button>

              <button className={styles.analyzeButton} onClick={() => handleAnalyser()}>
                ANALYSE
              </button>
            </div>
          </div>

          {/* Speedometer - Always on Right */}
          <div className="col-md-4 d-flex justify-content-center align-items-start" >
            <div className="text-center">
              <Speedometer speedometerValue={gaugeData?.speed} analyzed={analyzed} />
            </div>
          </div>
        </div>
      </div>

      <ModalBarChart_Params data={{ label: activeTab, barName: activeTab }} filterdata={filterdata} />
      <ModalGauge_Params data={initialData} />


    </div>
  );
};

export default ParametersSection;

